<template lang="pug">
mixin sidebar
  el-select.tags_filter(
    v-model='note_tags_filter'
    placeholder='标签筛选...'
    clearable
  )
    el-option(
      v-for='tag in tags'
      :value='tag'
      :key='tag'
    )
  el-collapse(v-model='collapse_items')
    el-collapse-item(name='general')
      template(slot='title')
        span 备忘录
        i.mi.right-floating-icon(@click='open_general_note_dialog()') add
      notes-list(
        :groups='general_notes'
        :show-label='false'
        :filter='note_tags_filter'
        @open='open_general_note_dialog'
      )

    el-collapse-item(title='状态跟踪', name='tracking')
      notes-list(
        :groups='rooms_has_tracking_notes'
        :filter='note_tags_filter'
        @open='open_tracking_note_dialog'
        @label-clicked='room => $router.$go.room({no: room.no})'
      )

.dashboard-container
  .dashboard-router(v-show='$route.path!=="/"')
    router-view

  .dashboard(v-show='$route.path==="/"')
    .rooms-overview
      el-tabs(v-model='filter')
        el-tab-pane(label='全部', :name='null')
        el-tab-pane(:label='"即将到期" + count(rooms_filter_expiring)', name='expiring')
        el-tab-pane(:label='"可预定" + count(rooms_filter_avaliable)', name='avaliable')
        el-tab-pane(label='已入住', name='checked')
        el-tab-pane(:label='"预定" + count(rooms_filter_perorder)', name='preorder')
        el-tab-pane(label='付款周期', name='pay_unit_month')

      template(v-if='$media.isPortableDevice')
        +sidebar

      template(v-for='(cates, key, index) in categoried_rooms', v-if='cates.length')
        .ui.horizontal.divider {{key}}
        .grid
          room-view(
            v-for='room in cates',
            :key='room.no',
            :room='room',
            @tracking-notes='open_tracking_note_dialog',
          )

      dialog-tracking-notes(
        :visible.sync='dialog_tracking.visible'
        :room='dialog_tracking.room'
      )
      dialog-general-note(
        :visible.sync='dialog_general.visible'
        :item='dialog_general.item'
      )

  .sidebar(v-if='!$media.isPortableDevice', v-show='$route.path==="/"')
    +sidebar
</template>

<script>
import _ from 'lodash'
import { RoomView, NotesList } from '../components/basic'
import { DialogTrackingNotes, DialogGeneralNote } from '../components/forms'
import { MixRoom } from '../mixins/index'

const DATE_SORTER = function (a, b) {
  const x = this.room_days_to_expired(a)
  const y = this.room_days_to_expired(b)
  if (x < y)
    return -1
  else if (x > y)
    return 1
  return 0
}

export default {
  name: 'dashboard',
  components: {
    DialogTrackingNotes,
    DialogGeneralNote,
    RoomView,
    NotesList,
  },
  mixins: [MixRoom],
  computed: {
    rooms() {
      return this.$store.getters.rooms
    },
    rooms_sorted() {
      return [...this.rooms].sort(DATE_SORTER.bind(this))
    },
    rooms_filter_avaliable() {
      return this.rooms_sorted
        .filter(room => {
          if ((this.room_preorders(room) || []).length)
            return false
          if (this.room_state(room) === 'avaliable')
            return true
          if (this.room_state(room) === 'delegated')
            return true
          const contract = this.room_current_contract(room)
          return contract && contract.preorderable === 1
        })
    },
    rooms_filter_checked() {
      return this.rooms
        .filter(room => this.room_state(room) === 'checked')
    },
    rooms_filter_expiring() {
      const level = this.$config.warning_color_levels[0]
      return this.rooms_sorted
        .filter(room => this.room_days_to_expired(room) < level)
    },
    rooms_filter_perorder() {
      return this.rooms
        .filter(room => (this.room_preorders(room) || []).length)
    },
    filtered_rooms() {
      if (this.filter === 'avaliable')
        return this.rooms_filter_avaliable
      else if (this.filter === 'checked')
        return this.rooms_filter_checked
      else if (this.filter === 'expiring')
        return this.rooms_filter_expiring
      else if (this.filter === 'preorder')
        return this.rooms_filter_perorder
      else if (this.filter === 'pay_unit_month')
        return this.rooms_sorted

      return this.rooms
    },
    categoried() {
      if (this.filter === 'expiring')
        return 'expiring'
      else if (this.filter === 'avaliable')
        return ''
      else if (this.filter === 'pay_unit_month')
        return 'pay_unit_month'
      return 'room'
    },
    categoried_rooms() {
      if (!this.categoried)
        return { Rooms: this.filtered_rooms }
      const categoried = {
        default: [],
        空闲: [],
      }

      if (this.categoried === 'room') {
        for (const room of this.filtered_rooms) {
          const cate = room.category
          if (cate) {
            if (!categoried[cate])
              categoried[cate] = [room]
            else
              categoried[cate].push(room)
          } else
            categoried.default.push(room)
        }
      } else if (this.categoried === 'pay_unit_month') {
        for (const room of this.filtered_rooms) {
          const month = this.room_pay_unit_month(room)
          const cate = this.$formatters.pay_unit_month(month)
          if (month !== undefined && cate) {
            if (!categoried[cate])
              categoried[cate] = [room]
            else
              categoried[cate].push(room)
          } else
            categoried['空闲'].push(room)
        }
      } else if (this.categoried === 'expiring') {
        for (const room of this.filtered_rooms) {
          const contract = this.room_current_contract(room)
          const preorders = this.room_preorders(room).filter(p => p.state === 'active')
          let cate = '其他'
          if (preorders.length)
            cate = '已预订'
          else if (contract) {
            if (contract.date_end !== contract.date_expire)
              cate = '租金到期'
            else if (contract.preorderable === 1)
              cate = '可预订'
            else if (contract.preorderable === 2)
              cate = '确认续租'
            else
              cate = '合同到期'
          }
          if (!categoried[cate])
            categoried[cate] = [room]
          else
            categoried[cate].push(room)
        }
      }
      return categoried
    },
    rooms_has_tracking_notes() {
      return this.filtered_rooms
        .map(room => ({ _id: room._id, no: room.no, notes: (room.tracking_notes || []).filter(i => !i.state) }))
        .filter(room => room.notes.length)
        .sort((a, b) => new Date(b.notes[0].time_modified) - new Date(a.notes[0].time_modified))
    },
    general_notes() {
      return this.$store.state.summary.notes.map(note => ({
        notes: [note],
        pinned: note.pinned,
      }))
    },
    tags() {
      const set = new Set()
      _.concat(
        this.general_notes,
        this.rooms_has_tracking_notes,
      ).forEach(({ notes = [] }) => {
        notes.forEach(({ tags = [] }) => {
          tags.forEach(tag => {
            set.add(tag)
          })
        })
      })
      return Array.from(set)
    },
  },
  data() {
    return {
      filter: null,
      dialog_tracking: {
        room: null,
        visible: false,
      },
      dialog_general: {
        item: null,
        visible: false,
      },
      collapse_items: this.$media.isMobile ? null : ['general', 'tracking'],
      note_tags_filter: '',
    }
  },
  methods: {
    count(by) {
      if (by.length)
        return `(${by.length})`
      return ''
    },
    open_tracking_note_dialog({ _id, no, notes }) {
      this.dialog_tracking.room = { _id, no, tracking_notes: notes }
      this.dialog_tracking.visible = true
    },
    open_general_note_dialog(item) {
      this.dialog_general.item = item ? item.notes[0] : {}
      this.dialog_general.visible = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?9e834bd6